import { render, staticRenderFns } from "./checkRiskTwo.vue?vue&type=template&id=1cbfa9c9&scoped=true&"
import script from "./checkRiskTwo.vue?vue&type=script&lang=js&"
export * from "./checkRiskTwo.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskTwo.vue?vue&type=style&index=0&id=1cbfa9c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbfa9c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbfa9c9')) {
      api.createRecord('1cbfa9c9', component.options)
    } else {
      api.reload('1cbfa9c9', component.options)
    }
    module.hot.accept("./checkRiskTwo.vue?vue&type=template&id=1cbfa9c9&scoped=true&", function () {
      api.rerender('1cbfa9c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/checkRiskTwo.vue"
export default component.exports